import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export const useVisitReasons = () => useQuery({ queryKey: ["vet-reasons"], staleTime: 3600e3,
  queryFn: async () => (await api.get("/veterinary/visit-reasons")).data.items });

// Searchable multi-select; value = [{id, note}]
export function VisitReasonPicker({ value = [], onChange, error }) {
  const { data: opts = [] } = useVisitReasons();
  const [q, setQ] = useState("");
  const has = (id) => value.some((v) => v.id === id);
  const toggle = (id) => onChange(has(id) ? value.filter((v) => v.id !== id) : [...value, { id, note: "" }]);
  const other = value.find((v) => v.id === "other");
  const shown = opts.filter((o) => o.label.toLowerCase().includes(q.toLowerCase()));
  return (
    <div data-field="visit_reasons" data-testid="visit-reason-picker">
      <p className="text-xs font-semibold text-slate-700">Reason for visit <span className="text-rose-600">*</span></p>
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search reasons…" data-testid="visit-reason-search"
        className="mt-1 w-full rounded-md border border-slate-200 px-2 py-1.5 text-sm" />
      <div className="mt-2 flex flex-wrap gap-1.5">
        {shown.map((o) => (
          <button type="button" key={o.id} onClick={() => toggle(o.id)} data-testid={`visit-reason-${o.id}`}
            className={`rounded-full border px-2.5 py-1 text-xs font-medium transition-colors ${has(o.id) ? "border-sky-600 bg-sky-600 text-white" : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50"}`}>{o.label}</button>
        ))}
      </div>
      {other && <input value={other.note} onChange={(e) => onChange(value.map((v) => (v.id === "other" ? { ...v, note: e.target.value } : v)))}
        placeholder="Describe the other reason" maxLength={120} data-testid="visit-reason-other-note" className="mt-2 w-full rounded-md border border-slate-200 px-2 py-1.5 text-sm" />}
      {error && <p className="mt-1 text-xs text-rose-600" data-testid="visit-reason-error">{error}</p>}
    </div>
  );
}

export const reasonsError = (v) => (!v.length ? "Select at least one reason for the vet visit." : v.some((x) => x.id === "other" && !x.note.trim()) ? "Describe the 'Other' reason." : "");

export const ReasonChips = ({ reasons, testid }) => (reasons?.length ? (
  <span className="inline-flex flex-wrap gap-1" data-testid={testid}>
    {reasons.map((r) => <span key={r.id} className="rounded bg-sky-50 px-1.5 py-0.5 text-[10px] font-semibold text-sky-700">{r.label}{r.note ? `: ${r.note}` : ""}</span>)}
  </span>
) : null);
